import React from "react";

export class ErrorBoundary extends React.Component {
    constructor(props:any) {
      super(props);
      this.state = { hasError: false } ;
    }
  
    static getDerivedStateFromError(error:any) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error:any, errorInfo:any) {
      // You can also log the error to an error reporting service
      console.error(error, errorInfo)

    }
  
    render() {
      if ((this.state as any).hasError) {
        // You can render any custom fallback UI
        return <div style={{textAlign: 'center', margin: '20px'}}>Something went wrong, and this page is unable to load. Please retry, or contact your administrator.</div>
      }
  
      return this.props.children; 
    }
  }